module.exports = __webpack_public_path__ + "img/fukidashi-p03.e29adbef.png";